/**
 * Theme JS building
 */
import 'jquery-touchswipe';
import './modernizr';
import Theme from './theme';
import PageContacts from './page-contacts';

// Export the theme controller for global usage.
window.Theme = new Theme();

// Require main style file here for concatenation.
import '../styles/main.scss';



// WEBPACK FOOTER //
// ./assets/scripts/main.js